import { ApolloError } from '@apollo/client';
import Avatar from '@mui/material/Avatar';
import CheckIcon from '@mui/icons-material/Check';
import CourseProgress from '../models/CourseProgress';
import LinearProgress from '@mui/material/LinearProgress';
import React from 'react';
import styles from '../styles/CourseProgressBar.module.css';
import { useTheme } from '@mui/material/styles';

interface CourseProgressBarProps {
  loading: boolean;
  error: ApolloError;
  progress: CourseProgress;
}

const CourseProgressBar = (props: CourseProgressBarProps) => {
  if (props.error) {
    return (
      <div className={`${styles.courseProgress} ${styles.error}`}>
        <span>Failed to load progress data.</span>
      </div>
    );
  }

  if (props.loading) {
    return (
      <div className={styles.courseProgress}>
        <LinearProgress style={{ height: '100%' }} />
      </div>
    );
  }

  const started = props.progress?.started || 0;
  const completed = props.progress?.completed || 0;
  const status = props.progress?.status || 'NotStarted';

  const muiTheme = useTheme();
  const primaryColor = muiTheme.palette.primary.main;

  return (
    <div className={styles.courseProgress}>
      <div
        className={styles.progressSegment}
        style={{
          left: 0,
          width: `${completed}%`,
          backgroundColor: primaryColor
        }}
      ></div>
      <div
        className={styles.progressSegment}
        style={{
          left: `${completed}%`,
          width: `${started}%`,
          backgroundColor: primaryColor,
          opacity: 0.5
        }}
      ></div>
      {status === 'Completed' && (
        <Avatar className={styles.avatar}>
          <CheckIcon className={styles.icon} />
        </Avatar>
      )}
    </div>
  );
};

export default CourseProgressBar;
